import React, { useContext } from 'react';
import { AuthContext } from 'context/Context';

const UserName = () => {
  const { user } = useContext(AuthContext);
  return <p className="m-0">{user.first_name + ' ' + user.last_name}</p>;
};

export default UserName;
